import React from "react";

/**
 * AP-021 · Premium PageHeader — Global inheritance point.
 * ALL modules that use <PageHeader /> automatically get the Enterprise SaaS
 * treatment: eyebrow chip, oversized H1 with tracking-tight, subtitle with
 * emerald accent line, and right-aligned action slot.
 * DO NOT redesign per page — extend/change here only.
 */
export default function PageHeader({ title, subtitle, action, eyebrow, testid }) {
  return (
    <div
      data-testid={testid}
      className="jms-page-header flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8"
    >
      <div className="min-w-0">
        {eyebrow && (
          <p className="jms-eyebrow flex items-center gap-2 mb-2">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary" />
            {eyebrow}
          </p>
        )}
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 text-sm text-slate-600 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      {action && <div className="flex items-center gap-2 shrink-0">{action}</div>}
    </div>
  );
}
